import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-gray-333 basic-flow-create-container" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "title-personal" }
const _hoisted_4 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-4" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_8 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "font-size-14 font-bold" }
const _hoisted_11 = { class: "flex mt-8" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-2xl" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_TableFlow = _resolveComponent("TableFlow")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.dataFlowElement?.application_define_name)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.dataFlowElement.application_define_name), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6
      ]),
      (_ctx.dataFlowElement?.total_level)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('numberOfApprovedFlows')), 1),
            _createVNode(_component_Dropdown, {
              class: "w-20",
              "options-select": _ctx.numberOfApprovedFlowsList,
              modelValue: _ctx.dataFlowElement.total_level,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataFlowElement.total_level = $event))
            }, null, 8, ["options-select", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dataFlowElement?.total_level)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataFlowElement.total_level, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index + 'key',
                class: "mb-4"
              }, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t(`fullWidth${index + 1}`)) + _toDisplayString(_ctx.t('primaryApprovalFlow')), 1),
                  _createVNode(_component_TableFlow, {
                    data: _ctx.dataFlowElement.application_flow_details,
                    approval_level: index + 1,
                    parentKey: _ctx.parentKey,
                    listEmployee: _ctx.listEmployee,
                    listRole: _ctx.listRole,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors = $event)),
                    validated: _ctx.validated
                  }, null, 8, ["data", "approval_level", "parentKey", "listEmployee", "listRole", "errors", "validated"])
                ])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                class: "mr-4",
                onClick: _ctx.onSubmitCreateBasicFlow,
                disabled: _ctx.isDisableSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(_ctx.t('save')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_Button, {
                variant: "outline-primary",
                onClick: _ctx.backPersonalFlowSettingsList
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                disabled: _ctx.isBasicFlow === true || !_ctx.data.application_flow_id,
                variant: "danger",
                class: "ml-4",
                onClick: _ctx.resetPersonalFlowSettingsList
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('resetMember')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}